/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import {
  getUpdatableProducts,
  getProducts
} from '../../selectors/productSelector';
import SelectField from './selectField';

const ProductSelect = ({
  allowEdit,
  onSelectChange,
  selectedTeam,
  selectedProductId,
  updateableProducts,
  allProducts
}) => {
  let productsToMap;
  if (updateableProducts.length > 0) productsToMap = updateableProducts;
  else if (!allowEdit && selectedProductId)
    productsToMap = [allProducts.find((p) => p.id === selectedProductId)];
  else productsToMap = [];

  const productOptions = productsToMap.map((option) => ({
    label: option.short_name || option.name,
    value: option.id
  }));

  const selectedProduct = productOptions.find(
    (prod) => prod.value === selectedProductId
  );

  return (
    <SelectField
      label="Product"
      value={selectedProduct}
      options={productOptions}
      allowEdit={allowEdit}
      handleChange={onSelectChange}
      clearable={!isEmpty(selectedTeam)}
    />
  );
};

ProductSelect.propTypes = {
  allowEdit: PropTypes.bool.isRequired,
  selectedTeam: PropTypes.object,
  onSelectChange: PropTypes.func.isRequired,
  selectedProductId: PropTypes.number
};

ProductSelect.defaultProps = {
  selectedTeam: {}
};

const mapStateToProps = (state) => {
  return {
    updateableProducts: getUpdatableProducts(state),
    allProducts: getProducts(state)
  };
};

export default connect(mapStateToProps)(ProductSelect);
